import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowTopRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSquareArrowTopRight"><Path fillRule="evenodd" clipRule="evenodd" d="M13 3H21V11H19V6.41421L11 14.4142L9.58579 13L17.5858 5H13V3ZM3 5H10V7H5V19H17V14H19V21H3V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareArrowTopRight;
